// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__esIfz","actionsCol":"EnrolledClinics_actionsCol__1HR2C"};